// extracted by mini-css-extract-plugin
export var dateHolder = "postCard-module--dateHolder--u4JXf";
export var postCard = "postCard-module--postCard--+PorL";
export var postCardImg = "postCard-module--postCardImg--aKHzI";
export var title = "postCard-module--title--YyFMa";